import { action } from "satcheljs";

import type { Collaborator } from "../serviceTypes/Collaborator";

/**
 * Action called when any changes to a collaborator are made
 */
export interface CollaboratorUpdatedActionActionMessage {
    collaborator: Collaborator;
    actionType: "added" | "removed";
}
export const collaboratorUpdatedAction: (collaborator: Collaborator, actionType: "added" | "removed") => CollaboratorUpdatedActionActionMessage = action("collaboratorUpdatedAction", (collaborator: Collaborator, actionType: "added" | "removed"): CollaboratorUpdatedActionActionMessage => ({
    collaborator,
    actionType,
}));
